import { getDecimalFormat, getPercentFormat } from '@/i18n/numbers'
import moment from 'moment'

const { parse } = require('json2csv')

export default {
  methods: {
    exportChartToCSV: function (ctx, w, filename, options = {}) {

    },
    exportToCSV ({ ctx, w, series, filename = null, columnDelimiter = ',', lineDelimiter = '\n', options }) {

    },
    triggerDownload: function (href, filename = 'file', ext) {
      const downloadLink = document.createElement('a')
      downloadLink.href = href
      downloadLink.download = filename + ext
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    },

    downloadCsv: function (data, filename = 'data', ext = '.csv') {
      const href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(data)
      const downloadLink = document.createElement('a')
      downloadLink.href = href
      downloadLink.download = filename + ext
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    },
    getCSVFromColumnChart: function (data, xType = 'percent', yType, ignoreEmpty = true) {
      // Creamos las opciones del CSV, donde las categorías son los nombres de las series.
      const firstHeader = yType === 'date' ? 'date' : 'brand'
      const csvOptions = {
        delimiter: ';',
        fields: [firstHeader, ...data.series.map(serie => serie.name)] // Los nombres de las series serán las columnas
      }

      const csvData = []
      const categories = data.xAxis.categories // Fechas
      const series = data.series // Las series contienen el nombre y los datos

      // Recorremos las fechas (como categorías)
      for (let index = 0; index < categories.length; index++) {
        let category = categories[index]

        // Si el tipo de la categoría es 'fecha', aplicamos el formato
        if (yType === 'date') {
          category = moment(category, 'YYYY-MM-DD').format('D MMM, YY') // Formato 'D MMM, YY'
        }

        const row = { [firstHeader]: category }

        // Recorremos cada serie para obtener sus valores en esta fecha
        for (const serie of series) {
          let value = serie.data[index] // Tomamos el valor de la serie en la fecha actual (índice)

          if (!ignoreEmpty || value !== null) {
            // Si estamos manejando porcentaje o decimales, aplicamos el formato adecuado
            if (xType === 'percent') {
              value = getPercentFormat(value)
            } else {
              value = getDecimalFormat(value)
            }
            // Añadimos el valor a la fila con el nombre de la serie
            row[serie.name] = value
          }
        }

        // Añadimos la fila completa al CSV
        csvData.push(row)
      }

      // Generamos y retornamos el CSV
      return parse(csvData, csvOptions)
    },
    getCSVFromTreemapChart: function (data, xType = 'percent', firstHeader = 'category', ignoreEmpty = true) {
      console.log('firstHeader - data: ', firstHeader)
      // Definimos las opciones del CSV, donde los encabezados son dinámicos
      const treemapData = data.series[0].data
      const items = Array.from(new Set(treemapData.filter(item => item.parent).map(item => item.name)))

      // Creamos las opciones del CSV con el primer encabezado dinámico
      const csvOptions = {
        delimiter: ';',
        fields: [firstHeader, 'general', ...items] // 'firstHeader (parámetro)' o 'general' como encabezado
      }

      let total = 0
      const csvData = []
      const categories = data.series[0].data.filter(c => c.parent == null)
      const categoriesName = categories.map(c => c.name)

      // Recorrimos las categorías para crear los datos del CSV
      for (const category of categoriesName) {
        const itemData = treemapData.filter(i => i.parent === category)
        const general = itemData.map(i => i.value).reduce((a, b) => a + b, 0)
        total += general

        // Crear la fila con el nombre de la categoría y el valor general
        const item = {
          [firstHeader]: category, // Dinámico: 'category' o 'general'
          general,
          ...itemData.reduce((a, v) => ({ ...a, [v.name]: v.value }), {})
        }

        csvData.push(item)
      }

      // Si tiene el parámetro 'percent'convertimos los valores a porcentaje
      if (xType === 'percent') {
        for (const object of csvData) {
          for (const key in object) {
            if (key !== firstHeader) { // Excluimos el primer encabezado (category o general)
              object[key] = getPercentFormat((object[key] * 100) / total)
            }
          }
        }
      }

      // Generamos y retornamos el CSV con las opciones definidas
      return parse(csvData, csvOptions)
    }

  }
}
